export default "__VITE_ASSET__B$zpMo4f__"